export function selectRuntimeEndpoint({ appType, interactionMode, endpoints }) {
  if (appType === 'workflow') {
    return endpoints.workflow;
  }
  if (interactionMode === 'chat') {
    return endpoints.chat;
  }
  return endpoints.completion;
}

export function buildRuntimeRequest(prompt, options = {}) {
  const { user, ...runtimeOptions } = options;
  if (prompt && typeof prompt === 'object') {
    const query = String(prompt.query || prompt.inputs?.query || '').trim();
    return {
      inputs: {
        ...(prompt.inputs || {}),
        query,
      },
      query,
      response_mode: 'blocking',
      ...(user ? { user } : {}),
      ...runtimeOptions,
    };
  }
  const query = String(prompt || '').trim();
  return {
    inputs: {
      query,
    },
    query,
    response_mode: 'blocking',
    ...(user ? { user } : {}),
    ...runtimeOptions,
  };
}
